import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
  Divider,
  Snackbar,
  Alert,
} from "@mui/material";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import { GoogleLogin } from "@react-oauth/google";

/* ✅ API URL */
const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3007";

export const AdminSignIn = () => {
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      if (!credentialResponse || !credentialResponse.credential) return;

      const res = await fetch(`${API_URL}/api/auth/google`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_token: credentialResponse.credential,
          isAdminSignin: true, // ✅ ADMIN FLAG
        }),
      });

      const data = await res.json();

      if (data.success) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("userEmail", data.user.email);
        localStorage.setItem("userRole", data.user.role);

        console.log("[AdminSignIn] Google admin login:", { email: data.user.email, role: data.user.role });

        if (data.user.role === "admin") {
          navigate("/admin");
        } else {
          setSnackbar({
            open: true,
            message: "Sorry, you don’t have admin access",
            severity: "error",
          });
        }
      } else {
        console.warn("[AdminSignIn] Google login response missing success:", data);
        setSnackbar({
          open: true,
          message: data.error || data.message || "Google login failed",
          severity: "error",
        });
      }
    } catch (err) {
      console.error("Google login error:", err);
      setSnackbar({
        open: true,
        message: "Google login failed. Please try again.",
        severity: "error",
      });
    }
  };

  const handleGoogleError = () => {
    console.error("Google Login Failed");
    setSnackbar({
      open: true,
      message: "Google login failed. Please try again.",
      severity: "error",
    });
  };

  return (
    <>
      <Header />
      <Box
        sx={{
          background: "linear-gradient(180deg, #000 0%, #111 100%)",
          color: "white",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: 6,
        }}
      >
        <Container maxWidth="sm">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <Paper
              elevation={6}
              sx={{
                p: 4,
                borderRadius: 3,
                background: "rgba(255,255,255,0.05)",
                backdropFilter: "blur(10px)",
              }}
            >
              <Typography
                variant="h4"
                textAlign="center"
                fontWeight="bold"
                gutterBottom
                sx={{
                  background: "linear-gradient(90deg, #fff, #00bcd4)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Admin
              </Typography>

              <Box
                component="form"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  mt: 3,
                }}
                onSubmit={(e) => e.preventDefault()}
              >
                <TextField
                  label="Email"
                  variant="outlined"
                  fullWidth
                  required
                  InputLabelProps={{ style: { color: "#aaa" } }}
                  InputProps={{ style: { color: "white" } }}
                />
                <TextField
                  label="Password"
                  type="password"
                  variant="outlined"
                  fullWidth
                  required
                  InputLabelProps={{ style: { color: "#aaa" } }}
                  InputProps={{ style: { color: "white" } }}
                />
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 2,
                    py: 1.5,
                    fontWeight: 600,
                    backgroundColor: "#00bcd4",
                    "&:hover": { backgroundColor: "#00acc1" },
                  }}
                >
                  Sign In
                </Button>
              </Box>

              <Divider
                sx={{ my: 3, backgroundColor: "rgba(255,255,255,0.2)" }}
              >
                or
              </Divider>

              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <GoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={handleGoogleError}
                  useOneTap
                />
              </Box>

              <Typography
                variant="body2"
                textAlign="center"
                sx={{ mt: 3, color: "rgba(255,255,255,0.7)" }}
              >
                Don’t have an account?{" "}
                <Link to="/signup" style={{ color: "#00bcd4" }}>
                  Sign Up
                </Link>
              </Typography>

              <Typography
                variant="body2"
                textAlign="center"
                sx={{ mt: 3, color: "rgba(255,255,255,0.7)" }}
              >
                Already have an Account?{" "}
                <Link to="/signin" style={{ color: "#00bcd4" }}>
                  Sign In
                </Link>
              </Typography>
            </Paper>
          </motion.div>
        </Container>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AdminSignIn;
